const Customer = {

    // FIELDS
    "personal_information": "Personal Information",
    "customer_name": "Customer Name",
    "short_name": "Short Name",
    "customer_category": "Customer Category",
    "grade": "Grade",

    "contact_information": "Contact Information",
    "customer_type": "Customer Type",
    "postal_code": "Zip Code",
    "city": "City",
    "po_box": "PO Box",
    "website": "Website",
    "fax": "Fax",
    "office_no": "Office Contact Number",
    "address": "Address",
    "status": "Status",

    "rebate": "Rebate/Discount",
    "slab": "Slab",
    "from_amount": "From Amount",
    "to_amount": "To Amount",
    "discount": "Discount %",

    "person_information": "Person Information",
    "person_name": "Person Name",
    "designation": "Designation",
    "department": "Department",
    "mobile": "Mobile",
    "email": "Email",

    "general_information": "General Information",
    "tax_type": "Tax Type",
    "currency": "Currency",
    "customer_group": "Customer Group",
    "black_listed": "Black Listed",
    "region": "Region",
    "vat_no": "VAT Number",
    "pan_no": "PAN Number",
    "registration_no": "Registration Number",
    "credit_days": "Credit Days",
    "credit_limit": "Credit Limit",
    "search_location": "Search Location",
    "lat": "Latitude",
    "lng": "Longitude",

    "dispatch_information": "Customer Dispatch Detail",
    "same_check": "Same as Customer Address",
    "name": "Name",
    "gst_no": "GST No",
    "priority": "Priority",
    "search": "Search",

    // PAGE HEADER  
    "customer": "Customer",

    // TOOLTIP
    "active": "Activate",
    "de_active": "De-Activate",

    // SWEET ALERT
    "active_confirm_text": "Are You Sure Want To Activate Customer?",
    "deactive_confirm_text": "Are You Sure Want To De-Activate Customer?",
    "status_text": "Status Successfully Changed",

    // ERROR
    "error_customer_name": "Enter Customer Name",
    "error_short_name": "Enter Short Name",
    "error_customer_category": "Select Customer Category",
    "error_grade": "Select Grade",
    "error_customer_type": "Select Customer Type",
    "error_postal_code": "Enter Zip Code",
    "error_city": "Select City",
    "error_po_box": "Enter PO Box Number",
    "error_website": "Enter Website Link",
    "error_fax": "Enter Fax Number",
    "error_office_no": "Enter Office Number",
    "error_address": "Enter Address",
    "error_status": "Select Status",
    "error_person_name": "Enter Name",
    "error_designation": "Enter Designation",
    "error_department": "Select Department",
    "error_mobile": "Enter Mobile Number",
    "error_email": "Enter Email",
    "error_tax_type": "Select Tax Type",
    "error_currency": "Select Currency",
    "error_customer_group": "Select Customer Group",
    "error_black_listed": "Select Blacklisted",
    "error_region": "Select Region",
    "error_vat_no": "Enter VAT Number",
    "error_pan_no": "Enter PAN Number",
    "error_register_no": "Enter Registration Number",
    "error_credit_days": "Enter Credit Days",
    "error_credit_limit": "Enter Credit Limit",
    "error_lat": "Enter Latitude",
    "error_lng": "Enter Longitude",
    "error_tax_no": "Enter Tax Number",
    "error_priority": "Enter Priority",
    "error_type_error": "Enter only number",
    "error_from_amt": "Enter From Amount",
    "error_to_amt": "Enter To Amount",
    "error_discount": "Enter Discount",
    "error_greater_from": "Must be greater than From",
    "error_negative": "Cannot be negative",
    "error_greater": "Cannot be greater than 100",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_grade": 'GRADE',
    "table_type": "TYPE",
    "table_city": "CITY",
    "table_customer_cat": "CUSTOMER CATEGORY",
    "table_status": "STATUS",

    // DETAILS
    "contact_no": "Contact No",
    "category": "Category",
    "type": "Type",
    "vat_no_dtl": "VAT No",
    "pan_no_dtl": "PAN No",
    "registration_no_dtl": "Registration No",
    "sales": "Sales",
    "payment": "Payment",
    "total_order": "Total Order",
    "pending_order": "Pending Order",

    // DETAILS TAB
    "orders": "Orders",
    "dispatch_address": "Dispatch Address",
    "name": "Name",
    "tax_no": "Tax No (VAT/GST)",
    "order_id": "ORDER ID",
    "payment_id": "PAYMENT ID",
    "amount": "AMOUNT",
    "date": "DATE",

}

export default Customer;